import React, { useState } from 'react';
import {
  Dropdown,
  DropdownOverlay,
  AutoComplete,
  ActionList,
  ActionListItem,
} from '@razorpay/blade/components';
import { statesOfIndia } from 'utils/StatesOfIndia';
import { RegisterGenericType } from 'forms/useRegister';
import { statesOfIndiaCodeMap } from 'components/EmployeeDetails/StatutoryContributions/data';

type SelectOfficeLocationProps = {
  formData: Partial<{ officeLocation: string[] }>;
  registerFormData: RegisterGenericType<{ officeLocation: string[] }>;
};

export const SelectOfficeLocation = ({ registerFormData, formData }: SelectOfficeLocationProps) => {
  const [searchState, setSearchState] = useState<string | undefined>(
    formData.officeLocation?.[0] ? statesOfIndiaCodeMap[Number(formData.officeLocation[0])] : '',
  );

  const officeLocations = statesOfIndia.filter((state) => {
    return searchState ? state.name.toLowerCase().includes(searchState.toLowerCase()) : true;
  });

  return (
    <Dropdown
      selectionType="single"
      onOpenChange={(isOpen) => {
        if (isOpen) {
          setSearchState('');
        } else {
          setSearchState(
            formData.officeLocation?.[0]
              ? statesOfIndiaCodeMap[Number(formData.officeLocation[0])]
              : '',
          );
        }
      }}>
      <AutoComplete
        {...registerFormData('officeLocation', 'select')}
        label="Office Location"
        placeholder="Eg. Karnataka"
        necessityIndicator="required"
        isRequired
        inputValue={searchState || ''}
        onInputValueChange={({ value }) => {
          setSearchState(value);
        }}
        filteredValues={officeLocations.map((state) => state.code.toString())}
      />
      <DropdownOverlay>
        <ActionList>
          {officeLocations.map((location) => (
            <ActionListItem
              key={location.code}
              title={location.name}
              value={location.code.toString()}
              isSelected={formData.officeLocation?.[0] === location.code.toString()}
            />
          ))}
        </ActionList>
      </DropdownOverlay>
    </Dropdown>
  );
};
